import React, { useState } from 'react';
import styled from 'styled-components';
import BorderLinearProgress from '../../../components/ui/linear-progress/BorderLinearProgress';
import IconButton from '../../../components/ui/button/IconButton';
import FlexBox from '../../../components/ui/flexbox/FlexBox';
import Image from '../../../components/ui/image/Image';
import Overlay from '../../../components/ui/tooltip/Overlay';
import { getIconSource } from '../utils/utils';
import { ReactComponent as PlusIcon } from '../images/icon-plus.svg';

interface PlayPauseButtonProps {
	$disabled: boolean;
}

const PlayPauseButton = styled(Image)<PlayPauseButtonProps>`
	filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.3));
	&:hover {
		cursor: ${(props) => (!props.$disabled ? 'pointer' : 'not-allowed')};
	}
`;

const Wrapper = styled.div`
	width: 100%;
	margin-left: 10px;
`;

const Text = styled.span`
	color: var(--color-light-gray);
	font-size: 15px;
`;

const AvailableSoon = styled.div`
	font-style: italic;
	color: var(--color-dark-gray);
	font-size: 14px;
	font-weight: 400;
`;

interface DocumentActionsProps {
	text: string;
	onPlay: () => void;
	onPause: () => void;
	onAddToPlaylist?: () => void;
	isPlaying: boolean;
	progress: number;
	disabled?: boolean;
	isSummary?: boolean;
}

const DocumentActions: React.FC<DocumentActionsProps> = ({
	text,
	onPlay,
	onPause,
	onAddToPlaylist,
	isPlaying,
	progress,
	disabled = false
}) => {
	const [isPressed, setIsPressed] = useState(false);

	const handleMouseDown = () => {
		if (!disabled) {
			setIsPressed(true);
		}
	};

	const handleMouseUp = () => {
		if (!disabled) {
			setIsPressed(false);
		}
	};

	const handleClickPlayPause = () => {
		if (isPlaying) {
			onPause();
		} else {
			onPlay();
		}
	};

	return (
		<FlexBox $alignItems="center">
			<PlayPauseButton
				src={getIconSource(disabled, isPlaying, isPressed)}
				width="30px"
				height="30px"
				onMouseDown={handleMouseDown}
				onMouseUp={handleMouseUp}
				onMouseLeave={handleMouseUp}
				onClick={handleClickPlayPause}
				$disabled={disabled}
				alt="Play icon"
			/>
			<Wrapper>
				<FlexBox $alignItems="center" $justifyContent="space-between">
					<Text>{text}</Text>
					{!disabled && onAddToPlaylist && (
						<Overlay text="Add to playlist">
							<IconButton onClick={onAddToPlaylist}>
								<PlusIcon width="16" height="16" />
  </IconButton>
            </Overlay>
          )}
        </FlexBox>
        {!disabled && (
          <BorderLinearProgress variant="determinate" value={progress} />
        )}
        {disabled && <AvailableSoon>Available soon</AvailableSoon>}
      </Wrapper>
    </FlexBox>
  );
};

export default DocumentActions;
